module.exports = __webpack_public_path__ + "static/media/video_4.21894f5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/views/help/videos/video_4.mp4
// module id = QeLP
// module chunks = 0